import { Container } from '@pets-ui/Container/Container'
import { type MobileMediaQuery } from '@pets-ui/tokens/breakpoints.stylex'
import * as stylex from '@stylexjs/stylex'
import { BrandChip } from '../../../../../components/BrandChip/BrandChip'
import { ScrollableList } from '../../../../../components/ScrollableList/ScrollableList'
import { useCampaignBrands } from '../../../../../hooks/use-campaign-brands'

const MOBILE: MobileMediaQuery = '@media (max-width: 480px)'

const styles = stylex.create({
  root: {
    paddingBlock: {
      [MOBILE]: 8,
      default: 12,
    },
  },
})

export const BrandSelector = () => {
  const { brands, projectCode, switchBrand } = useCampaignBrands()

  if (brands.length <= 1) return null

  return (
    <Container px={3} rootStyle={styles.root}>
      <ScrollableList gap={2} showArrowsOnMobile>
        {brands.map(brand => (
          <BrandChip
            key={brand.project_code}
            imageSrc={brand.brand_image}
            imageAlt={brand.brand_name}
            size="small"
            selected={brand.project_code === projectCode}
            onClick={() => switchBrand(brand.project_code)}
          />
        ))}
      </ScrollableList>
    </Container>
  )
}
